/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for SearchFormationResource controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_FORMATIONAPI, CLIENT_CONTEXT_TOKEN_FORMATIONAPI } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { RequestOptions, PagedModelFormationListDTO, FormationListDTO } from "../models";

@Injectable({ providedIn: "root" })
export class SearchFormationResourceService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_FORMATIONAPI);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_FORMATIONAPI;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'formationApi');
    }

    findFormation(q: string, page?: number, size?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<PagedModelFormationListDTO>;
    findFormation(q: string, page?: number, size?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PagedModelFormationListDTO>>;
    findFormation(q: string, page?: number, size?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PagedModelFormationListDTO>>;
    findFormation(q: string, page?: number, size?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/search/formations`;

        let params = new HttpParams();
        if (q != null) {
            params = HttpParamsBuilder.addToHttpParams(params, q, 'q');
        }
        if (page != null) {
            params = HttpParamsBuilder.addToHttpParams(params, page, 'page');
        }
        if (size != null) {
            params = HttpParamsBuilder.addToHttpParams(params, size, 'size');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findFicheFormation(id: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<FormationListDTO>;
    findFicheFormation(id: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<FormationListDTO>>;
    findFicheFormation(id: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<FormationListDTO>>;
    findFicheFormation(id: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/search/formations/fiche`;

        let params = new HttpParams();
        if (id != null) {
            params = HttpParamsBuilder.addToHttpParams(params, id, 'id');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    findByDomaine(code: string, page?: number, size?: number, observe?: 'body', options?: RequestOptions<'json'>): Observable<PagedModelFormationListDTO>;
    findByDomaine(code: string, page?: number, size?: number, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<PagedModelFormationListDTO>>;
    findByDomaine(code: string, page?: number, size?: number, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<PagedModelFormationListDTO>>;
    findByDomaine(code: string, page?: number, size?: number, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/search/formations/domaines`;

        let params = new HttpParams();
        if (code != null) {
            params = HttpParamsBuilder.addToHttpParams(params, code, 'code');
        }
        if (page != null) {
            params = HttpParamsBuilder.addToHttpParams(params, page, 'page');
        }
        if (size != null) {
            params = HttpParamsBuilder.addToHttpParams(params, size, 'size');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Advertise the response content type declared in the spec
        if (!headers.has('Accept')) {
            headers = headers.set('Accept', 'application/json');
        }

        return this.httpClient.request('get', url, {
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
